export const WIN_MESSAGES = ['Ez igen!', 'Szép munka!', 'Megcsináltad!']
